import { render } from "./StudiesManagement.vue?vue&type=template&id=2449271e&scoped=true"
import script from "./StudiesManagement.vue?vue&type=script&lang=js"
export * from "./StudiesManagement.vue?vue&type=script&lang=js"

import "./StudiesManagement.vue?vue&type=style&index=0&id=2449271e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2449271e"]])

export default __exports__